import * as actionTypes from '../actions/MapActions.js';

// 36.746675
// -6.375104
const initialState = {
	lat: 53.47563160751544,
	lon: -2.242764630313572,
	zoom: 6,
	maps: [],
	mapUpdated: undefined,
	zoomToUpdate: 9
};

const AddNewMap = (state, action) => {
	const mapAlreadyExists = state.maps.find((el) => el.id === action.value.id) !== undefined;
	// make a copy of the existing array
	let newAddMaps = state.maps.slice();

	if (mapAlreadyExists) {
		newAddMaps = newAddMaps.filter(map => map.id !== action.value.id);
		newAddMaps.push({
			...action.value,
			coordinates: {
				CenterLatitude: state.lat,
				CenterLongitude: state.lon,
				zoom: state.zoom
			},
			topology: { twoG: [], threeG: [], fourG: [] },
			legend: { legendElements: [], title: '' },
			legendLeft: { legendElements: [], title: '' },
			updateEnd: false
		});
	} else {
		// modify the COPY, not the original
		newAddMaps.push({
			...action.value,
			coordinates: {
				CenterLatitude: state.lat,
				CenterLongitude: state.lon,
				zoom: state.zoom
			},
			topology: { twoG: [], threeG: [], fourG: [] },
			legend: { legendElements: [], title: '' },
			legendLeft: { legendElements: [], title: '' },
			updateEnd: false
		});
	}

	return {
		...state,
		maps: newAddMaps
	};
};

const UpdateCoordinates = (state, action) => {
	const newUpdateMaps = state.maps.map((item) => {
		if (item.id !== action.value.id) {
			// This isn't the item we care about - keep it as-is
			return item;
		}
		// Otherwise, this is the one we want - return an updated value
		return {
			...item,
			coordinates: action.value.newCoordinates,
			updateEnd: false
		};
	});
	return {
		...state,
		maps: newUpdateMaps,
		mapUpdated: action.value.id,
	};
};

const UpdateTopology = (state, action) => {
	const newTopologyMaps = state.maps.map((item) => {
		if (item.id !== action.value.id) {
			// This isn't the item we care about - keep it as-is
			return item;
		}
		// Otherwise, this is the one we want - return an updated value
		return {
			...item,
			topology: action.value.newTopology,
			updateEnd: true
		};
	});

	return {
		...state,
		maps: newTopologyMaps,
		mapUpdated: action.value.id,
	};
};

const UpdateLegend = (state, action) => {
	// console.log('update legend', action.value.id)
	const newLegendMaps = state.maps.map((item) => {
		if (item.id !== action.value.id) {
			// This isn't the item we care about - keep it as-is
			return item;
		}
		// Otherwise, this is the one we want - return an updated value
		return {
			...item,
			legend: action.value.newLegend,
			updateEnd: true
		};
	});

	return {
		...state,
		maps: newLegendMaps,
		mapUpdated: action.value.id,
	};
};

const UpdateLegendLeft = (state, action) => {
	// console.log('update legend', action.value.id)
	const newLegendMaps = state.maps.map((item) => {
		if (item.id !== action.value.id) {
			// This isn't the item we care about - keep it as-is
			return item;
		}
		// Otherwise, this is the one we want - return an updated value
		return {
			...item,
			legendLeft: action.value.newLegend,
			updateEnd: true
		};
	});

	return {
		...state,
		maps: newLegendMaps,
		mapUpdated: action.value.id,
	};
};

const UpdatePopup = (state, action) => {
	const newMaps = state.maps.map((item) => {
		if (item.id !== action.value.id) {
			// This isn't the item we care about - keep it as-is
			return item;
		}
		// Otherwise, this is the one we want - return an updated value
		return {
			...item,
			control: {
				...item.control,
				state: {
					...item.control.state,
					activePopup: [...action.value.activePopup]
				}
			}
		};
	});

	return {
		...state,
		maps: newMaps,
		mapUpdated: null,
	};
};

const UpdateOverlays = (state, action) => {
	const newMaps = state.maps.map((item) => {
		if (item.id !== action.value.id) {
			// This isn't the item we care about - keep it as-is
			return item;
		}
		// Otherwise, this is the one we want - return an updated value
		return {
			...item,
			control: {
				...item.control,
				state: {
					...item.control.state,
					activeLayers: [...action.value.activeLayers]
				}
			}
		};
	});

	return {
		...state,
		maps: newMaps,
		mapUpdated: null,
	};
};

const MapReducer = (state = initialState, action) => {
	switch (action.type) {
					case actionTypes.ADD_MAP:
						return AddNewMap(state, action);
					case actionTypes.UPDATE_COORDINATES:
						return UpdateCoordinates(state, action);
					case actionTypes.UPDATE_TOPOLOGY:
						return UpdateTopology(state, action);
					case actionTypes.UPDATE_LEGEND:
						return UpdateLegend(state, action);
					case actionTypes.UPDATE_LEGEND_LEFT:
						return UpdateLegendLeft(state, action);
					case actionTypes.UPDATE_POPUP:
						return UpdatePopup(state, action);
					case actionTypes.UPDATE_OVERLAYS:
						return UpdateOverlays(state, action);
					default:
						return state;
	}
};

export default MapReducer;
